// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_025a50318d--wrapper--1PsDa","item":"_025a50318d--item--Y72s2","count":"_025a50318d--count--cV_kL","button":"_025a50318d--button--1gpY1"};